// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"e18fac80","109":"c7346d86","664":"9ec5e26d","900":"102bd670"}[chunkId] + ".chunk.css";
};